import React, { useState, useMemo } from 'react';
import HeaderFirst from 'utils/HeaderFirst';
import CustomBootstrapTable from 'utils/reactTable';
import { useNavigate, useParams } from 'react-router-dom';
import '../ventes/client.css';
import TablePaginators from '../ventes/TablePaginator';
import { FiPaperclip } from 'react-icons/fi';
// import { useSelector } from 'react-redux';
// import { getUser } from 'redux/features/userSliceWithTokenValidation';
import { PAIEMENT_DETTE } from 'routes/navigation/navigationPaths';
import HeaderButton from 'utils/headerButton';
import useDettesData from './useDettesData';
import FilterableHeader from './FilterableHeader';
import TableLoader from 'components/Loader/TableLoader';
import { FaRedo } from 'react-icons/fa';

const DettePage = () => {
  //user connected
  // const userStatus = useSelector(getUser);
  const navigate = useNavigate();
  const { clientID: dossier_id } = useParams();
  const { updatedDettes, totalDettes, isLoading } = useDettesData(dossier_id);
  const donnees = updatedDettes;
  const [selectedRows, setSelectedRows] = useState([]);
  const [serachTerm, setSearchedTerm] = useState('');
  const [filters, setFilters] = useState({
    fournisseurs: [],
    dateStart: '',
    dateEnd: '',
    amountRange: [0, 1000000],
    minAmount: 0,
    maxAmount: 1000000,
  });

  console.log("Données des dettes: ", donnees);

  const handleRowSelect = (row, isSelect) => {
    if (isSelect) {
      setSelectedRows((prev) => [...prev, row.id]);
    } else {
      setSelectedRows((prev) => prev.filter((id) => id !== row.id));
    }
  };

  const handleSearchChange = (newSearchTerm) => {
    setSearchedTerm(newSearchTerm);
  };

  // Calculate filter options
  const filterOptions = useMemo(() => {
    const fournisseurs = new Set();
    let maxAmount = 1000000;

    donnees.forEach(dette => {
      const fournisseurName = dette.fournisseurs_details?.nom;
      if (fournisseurName) fournisseurs.add(fournisseurName);
      
      const amount = dette.montant_total || 0;
      if (amount > maxAmount) maxAmount = amount;
    });

    return {
      fournisseurs: Array.from(fournisseurs).sort((a, b) => a.localeCompare(b)).map(f => ({ value: f, label: f })),
      maxAmount: Math.max(1000000, Math.ceil(maxAmount))
    };
  }, [donnees]);

  

  const columns = [
    {
      dataField: 'id',
      text: 'N°',
      formatter: (cell, row) => (
        <div className="styleColonne" onClick={() => handleRowSelect(row)}>
          {cell}
        </div>
      ),
    },
    {
      dataField: 'fournisseurs_details',
      text: 'Fournisseur',
      headerFormatter: (col) => (
        <FilterableHeader
          column={col}
          type="text"
          options={filterOptions.fournisseurs}
          currentValue={filters?.fournisseurs}
          onFilterChange={(val) => setFilters({ ...filters, fournisseurs: val })}
        />
      ),
      formatter: (cell, row) => (
        <div className="styleColonne" onClick={() => handleRowSelect(row)}>
          {cell?.nom}
        </div>
      ),
    },
    {
      dataField: 'updated_at',
      text: 'Date',
      headerFormatter: (col) => (
        <FilterableHeader
          column={col}
          type="date"
          currentValue={{ start: filters?.dateStart, end: filters?.dateEnd }}
          onFilterChange={(val) => setFilters({ ...filters, dateStart: val.start, dateEnd: val.end })}
        />
      ),
      formatter: (cell, row) => {
        const date = new Date(cell);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const formattedDate = `${day}/${month}/${year} à ${hours}:${minutes}`;
        return <div onClick={() => handleRowSelect(row)}>{formattedDate}</div>;
      },
    },
    {
      dataField: 'montant_total',
      text: 'Montant total',
      headerFormatter: (col) => (
        <FilterableHeader
          column={col}
          type="amount"
          min={0}
          max={filterOptions.maxAmount}
          currentValue={filters?.amountRange ? filters.amountRange : [0, Math.min(1000000, filterOptions.maxAmount)]}
          onFilterChange={(val) => setFilters({ ...filters, minAmount: val[0], maxAmount: val[1], amountRange: val })}
        />
      ),
      formatter: (cell, row) => (
        <div className="styleColonne" onClick={() => handleRowSelect(row)}>
          {new Intl.NumberFormat('fr-FR').format(cell)} FCFA
        </div>
      ),
    },
    {
      dataField: 'montant_paye',
      text: 'Montant payé',
      formatter: (cell, row) => (
        <div className="styleColonne" onClick={() => handleRowSelect(row)}>
          {new Intl.NumberFormat('fr-FR').format(cell)} FCFA
        </div>
      ),
    },
    {
      dataField: 'reste_a_payer',
      text: 'Solde restant',
      formatter: (cell, row) => (
        <div className="styleColonne" onClick={() => handleRowSelect(row)}>
          <span style={{ color: cell > 0 ? '#d9534f' : '#28a745', fontWeight: 'bold' }}>
            {new Intl.NumberFormat('fr-FR').format(cell)} FCFA
          </span>
        </div>
      ),
    },
    {
      dataField: 'archived',
      text: 'Statut',
      formatter: (cell, row) => {
        const statusText = row.archived ? (
          <span style={{ color: 'red' }}>Archivée</span>
        ) : (
          'Active'
        );
        return <div onClick={() => handleRowSelect(row)}>{statusText}</div>;
      },
    },
    {
      dataField: 'piece_joint',
      text: <FiPaperclip />,
      headerFormatter: () => (
        <div className="d-flex align-items-center justify-content-between">
          <span><FiPaperclip /></span>
          <FaRedo
            title="Réinitialiser tous les filtres"
            className="text-muted cursor-pointer ms-2"
            style={{ cursor: 'pointer', fontSize: '1rem' }}
            onClick={(e) => {
              e.stopPropagation();
              setFilters({
                fournisseurs: [],
                dateStart: '',
                dateEnd: '',
                amountRange: [0, filterOptions.maxAmount],
                minAmount: 0,
                maxAmount: filterOptions.maxAmount
              });
            }}
          />
        </div>
      ),
      formatter: (cell, row) => (
        <div className="styleColonne" onClick={() => handleRowSelect(row)}>
          {cell ? (
            <a href={cell} target="_blank" rel="noopener noreferrer">
              Pièce jointe
            </a>
          ) : (
            <span>-</span>
          )}
        </div>
      ),
    },
  ];

  const [pageSize, setPageSize] = useState(10);
  const [paginationIndex, setPaginationIndex] = useState(0);
  const [viewArchived, setViewArchived] = useState(false);

  const handlePageChange = (newIndex) => {
    setPaginationIndex(newIndex);
  };

  const filteredData = donnees
    .filter((dette) => (viewArchived ? dette.archived : !dette.archived))
    .filter((dette) =>
      dette.fournisseurs_details?.nom
        ?.toLowerCase()
        .includes(serachTerm.toLowerCase())
    )
    .filter((dette) => {
      if (!filters.fournisseurs || filters.fournisseurs.length === 0) return true;
      return filters.fournisseurs.includes(dette.fournisseurs_details?.nom);
    })
    .filter((dette) => {
      if (!filters.dateStart && !filters.dateEnd) return true;
      const detteDate = new Date(dette.updated_at);
      if (filters.dateStart) {
        const dateStart = new Date(filters.dateStart);
        if (detteDate < dateStart) return false;
      }
      if (filters.dateEnd) {
        const dateEnd = new Date(filters.dateEnd);
        dateEnd.setHours(23, 59, 59, 999);
        if (detteDate > dateEnd) return false;
      }
      return true;
    })
    .filter((dette) => {
      if (!filters.amountRange) return true;
      const amount = dette.montant_total || 0;
      return amount >= filters.amountRange[0] && amount <= filters.amountRange[1];
    });

  const currentPageData = filteredData.slice(
    paginationIndex * pageSize,
    (paginationIndex + 1) * pageSize
  );

  // Define the action handler for TablePaginator
  const handleActionSelected = (action) => {
    if (action === 'archive') {
      setViewArchived(!viewArchived); // Toggle between viewing archived and active depenses
    } else {
      console.log(`Action selected: ${action}`);
      // Handle other actions as necessary
    }
  };

  // const onClickArchive = async () => {
  //   if (selectedRows.length === 1) {
  //     const selectedRowId = selectedRows[0];

  //     // Optional: Check if the dette is archived before attempting to update
  //     const dette = currentPageData.find((d) => d.id === selectedRowId);

  //     const newArchivedStatus = !dette.archived;
  //     await handleUpdateDette(selectedRowId, { archived: newArchivedStatus });
  //     toast.info(
  //       `dette ${newArchivedStatus ? 'archivée' : 'désarchivée'} avec succès.`
  //     );
  //     // Consider refetching updated data here to reflect changes
  //   } else {
  //     toast.warning('Veuillez sélectionner exactement une dette à archiver.');
  //   }
  // };

  // const DepensebuttonActions = {
  //   addExpense: () => {
  //     alert('Ajouter une action de dette');
  //   },
  // };

  const nom = (
    <>
    <div style={{ display: 'flex' }}>
      <h4 className="titre-dossier">Dettes</h4>
      <span className="nbrDossier">{filteredData?.length}</span>
    </div>
      <p className="fw-bold fs-5" style={{ color: "#991B1B" }}>
        <span className='fw-bold nbrDossier m-0'>Montant total des dettes : </span>  {new Intl.NumberFormat('fr-FR').format(totalDettes)} FCFA
    </p>
    
    </>
  );
  const description = (
    <div>Voici toutes vos dettes {viewArchived && 'archivées'}</div>
  );

  const handleEyesClick = () => {
    if (selectedRows.length === 1) {
      const selectedRowId = selectedRows[0];
      const detailDetteURL = `${selectedRowId}/`;
      navigate(detailDetteURL);
    }
  };

  const handleFormDette = () => {
    navigate(PAIEMENT_DETTE);
  };

  // Vérifier s'il y a des dettes avec solde restant
  const hasDettesAvailable = donnees.some(
    (dette) => dette.reste_a_payer > 0 && !dette.archived
  );

  return (
    <div
      className="global"
      style={{
        backgroundColor: 'white',
        minHeight: '500px',
        borderRadius: '20px',
        padding: '15px',
      }}
    >
      <div
        className="header pb-3"
        style={{
          backgroundColor: 'white',
          borderRadius: '10px',
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          flexWrap: 'wrap',
          // padding: "13px",
        }}
      >
        <HeaderFirst nom={nom} description={description} />
        <button
          type="button"
          className="btn btn-outline-dark"
          style={{
            borderRadius: '31px',
            border: '1px solid #AEAEAE',
            padding: '8px',
            opacity: hasDettesAvailable ? 1 : 0.5,
            cursor: hasDettesAvailable ? 'pointer' : 'not-allowed',
          }}
          onClick={handleFormDette}
          disabled={!hasDettesAvailable}
          title={!hasDettesAvailable ? 'Aucune dette à payer' : 'Enregistrer un paiement'}
        >
          <span style={ajoutFou}>+ Paiement au fournisseur</span>
        </button>
      </div>
      <HeaderButton
        isButtonsEnabled={selectedRows.length > 0}
        placeholder={'Rechercher une dette'}
        onSearchChange={handleSearchChange}
        onEyesClick={handleEyesClick}
        // buttonActions={DepensebuttonActions}
        // onClickArchive={onClickArchive}
        // onEditClick={onEditClick}
      />

      <div>
        {isLoading && (!donnees || donnees.length === 0) ? (
          <div style={{ background: '#ffffff', borderRadius: '12px', padding: '30px', border: '1px solid #e2eced' }}>
            <TableLoader
              message="Chargement des dettes fournisseurs..."
              subMessage="Calcul des montants dus, des restes à payer et des échéances"
              minHeight="280px"
            />
          </div>
        ) : donnees ? (
          <CustomBootstrapTable
            keyField="id"
            data={currentPageData}
            columns={columns}
            onSelectRow={handleRowSelect}
            // ... other props
          />
        ) : null}
      </div>
      {!isLoading && (!currentPageData || currentPageData.length === 0) && (
        <div className="d-flex justify-content-center fs-5 mt-4 text-muted">
          <p>Aucune dette à afficher.</p>
        </div>
      )}
      {/* pagination */}
      {currentPageData && (
        <TablePaginators
          paginationIndex={paginationIndex}
          setPaginationIndex={handlePageChange}
          dataLength={filteredData?.length}
          pageSize={pageSize}
          setPageSize={setPageSize}
          onActionSelected={handleActionSelected}
          isViewingArchived={viewArchived}
        />
      )}
    </div>
  );
};

const ajoutFou = {
  fontFamily: 'Montserrat',
  fontWeight: '600',
  fontSize: '13px',
};
export default DettePage;
